export const CRITICAL_PATH = {
  ACTIVE_CRITICAL_PATH_TAG: 'active-critical-path-tag',
  CRITICAL_PATH_TOOLTIP: 'critical-path-tooltip',
  CRITICAL_PATH_TAG: 'critical-path-tag',
  CRITICAL_PATH_TAG_TOOLTIP: 'critical-path-tag-tooltip',
  CRITICAL_PATH_PILL: 'critical-path-pill',
  CRITICAL_PATH_PILL_TOOLTIP: 'critical-path-pill-tooltip',
  CRITICAL_PATHS_BUTTON_TOOLTIP: 'critical-paths-button-tooltip',
  CRITICAL_PATHS_ICON_BUTTON: 'critical-paths-icon-button',
  CRITICAL_PATHS_WIDGET: 'critical-paths-widget',
  CRITICAL_PATHS_WIDGET_POPOVER: 'critical-paths-widget-popover',
  CRITICAL_PATHS_WIDGET_NAVIGATE_ICON: 'critical-paths-widget-navigate-icon',
  CRITICAL_PATHS_WIDGET_ACTIVITIES_ONLY_SWITCH: 'critical-paths-widget-activities-only-switch'
} as const;
